var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1215_7787",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1215_7787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.18325 5.30002V3.98336H11.8666V5.30002H6.18325ZM6.18325 7.63336V6.30002H11.8666V7.63336H6.18325ZM8.26659 15.0834H3.89992C3.25636 15.0834 2.70936 14.8573 2.25892 14.4052C1.80847 13.9531 1.58325 13.4041 1.58325 12.7584V9.96669H3.59992V0.900024H14.4333V6.13336L12.8666 7.70002V2.48336H5.18325V9.96669H10.5999L9.03325 11.5334H3.14992V12.7584C3.14992 12.9732 3.22214 13.1534 3.36659 13.2987C3.51103 13.444 3.68325 13.5167 3.88325 13.5167H8.26659V15.0834ZM9.26659 15.0834V12.6834L13.8999 8.06669L16.2833 10.45L11.6666 15.0834H9.26659ZM10.5166 13.8334H11.1499L13.1166 11.8539L12.8166 11.5352L12.4999 11.2334L10.5166 13.196V13.8334ZM12.8166 11.5334L12.4999 11.2334L13.1166 11.85L12.8166 11.5334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractEdit);
export default __webpack_public_path__ + "static/media/contract_edit.0db2dc285ff063ff261f5470e7747a9e.svg";
export { ForwardRef as ReactComponent };